import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'En el primer mes conseguí 9 clientes. Todos vinieron por el boca a boca del primer auto que hice con el protocolo. No gasté un peso en publicidad.',
    name: 'Rodrigo M.',
    role: 'Detailer profesional, Córdoba Capital'
  }, {
    quote: 'Yo ya lavaba autos pero no sabía que lo estaba haciendo mal. Con el Tomo 1 del MegaPack entendí por qué no conseguía que los clientes volvieran.',
    name: 'Lucas T.',
    role: 'Detailer, Buenos Aires'
  }, {
    quote: 'El Tomo 2 me cambió el negocio. Ahora cobro $120.000 por una corrección de pintura. Antes ni sabía que eso existía.',
    name: 'Matías R.',
    role: 'Detailer profesional, Rosario'
  }, {
    quote: 'Arrancé sin saber nada. En 3 semanas ya tenía mis primeros 4 clientes pagos gracias al MegaPack.',
    name: 'Sebastián P.',
    role: 'Detailer, Mendoza'
  }, {
    quote: 'Los scripts del Bono 3 me salvaron. Antes perdía clientes porque no sabía cómo responder las consultas. Ahora cierro el 80% de lo que me llega.',
    name: 'Gonzalo F.',
    role: 'Detailer, Santa Fe'
  }];
  return <section className="py-16 px-4 bg-white border-t border-gray-200" data-id="element-255">
      <div className="max-w-6xl mx-auto" data-id="element-256">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-257">
          Lo que dicen los que ya tienen
          <br data-id="element-258" /> el MegaPack Detailer Argentino
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-259">
          {testimonials.map((t, index) => <div key={index} className="bg-gray-50 p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col" data-id="element-260">
              <div className="flex gap-1 mb-3" data-id="element-261">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-262" />)}
              </div>
              <p className="text-base text-gray-800 font-medium italic mb-4 flex-1" data-id="element-263">
                "{t.quote}"
              </p>
              <div data-id="element-264">
                <p className="font-bold text-gray-900" data-id="element-265">{t.name}</p>
                <p className="text-gray-600 text-sm" data-id="element-266">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}